module.exports = __webpack_public_path__ + "static/thinkon-logo-120bddbeffccb4da9c9eb80758314366.png";